import type { GameContext, GameMiddleware } from "./types";

/**
 * Drives ZoneEffectManager each frame.
 *
 * Behaviour depends on what GameContext provides:
 * - Editor context: ctx.zoneEffectManager is the SceneManager's existing instance.
 * - Client context: ctx.zoneEffectManager is absent → no-op for now.
 *   (ZoneEffectManager lives in editor/js/; once moved to client/js/ this middleware
 *    will create its own instance automatically.)
 */
export class ZoneEffectsMiddleware implements GameMiddleware {
    private ctx!: GameContext;

    init(ctx: GameContext): void {
        this.ctx = ctx;
    }

    update(_delta: number): void {
        this.ctx.zoneEffectManager?.update(this.ctx.getActiveCamera());
    }
}
